// StringUtils replacement for turbocommons-ts
export class StringUtils {
  /**
   * Compare similarity between two strings as a percentage
   * @param str1 First string to compare
   * @param str2 Second string to compare
   * @returns Similarity percentage (0-100)
   */
  static compareSimilarityPercent(str1: string | null | undefined, str2: string | null | undefined): number {
    // Handle null/undefined cases
    if (!str1 && !str2) return 100;
    if (!str1 || !str2) return 0;
    
    // Convert to strings if needed
    const s1 = String(str1).toLowerCase();
    const s2 = String(str2).toLowerCase();
    
    if (s1 === s2) return 100;
    if (s1.length === 0 && s2.length === 0) return 100;
    if (s1.length === 0 || s2.length === 0) return 0;
    
    // Simple Levenshtein-based similarity calculation
    const maxLength = Math.max(s1.length, s2.length);
    const distance = this.levenshteinDistance(s1, s2);
    return Math.round(((maxLength - distance) / maxLength) * 100);
  }
  
  /**
   * Calculate Levenshtein distance between two strings
   */
  private static levenshteinDistance(s1: string, s2: string): number {
    const matrix = Array(s2.length + 1).fill(null).map(() => Array(s1.length + 1).fill(null));
    
    for (let i = 0; i <= s1.length; i++) matrix[0][i] = i;
    for (let j = 0; j <= s2.length; j++) matrix[j][0] = j;
    
    for (let j = 1; j <= s2.length; j++) {
      for (let i = 1; i <= s1.length; i++) {
        const indicator = s1[i - 1] === s2[j - 1] ? 0 : 1;
        matrix[j][i] = Math.min(
          matrix[j][i - 1] + 1,     // deletion
          matrix[j - 1][i] + 1,     // insertion
          matrix[j - 1][i - 1] + indicator  // substitution
        );
      }
    }
    
    return matrix[s2.length][s1.length];
  }
}